import { createContext, useContext } from 'react'

export const FloorplansContext = createContext({
  bedroomOptions: [],
  bedroomsFilter: 'all',
  setBedroomsFilter: () => {},
  planLevelsFilter: 'all',
  setPlanLevelsFilter: () => {},
  activePlan: null,
  setActivePlan: () => {},
})

export function useFloorplansContext() {
  return useContext(FloorplansContext)
}